var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Property, ChildProperty } from '@syncfusion/ej2-base';
/**
 * Configures splitter position and splitter bar.
 */
export class SplitterSettings extends ChildProperty {
}
__decorate([
    Property(null)
], SplitterSettings.prototype, "position", void 0);
__decorate([
    Property(-1)
], SplitterSettings.prototype, "columnIndex", void 0);
__decorate([
    Property(4)
], SplitterSettings.prototype, "separatorSize", void 0);
__decorate([
    Property(null)
], SplitterSettings.prototype, "minimum", void 0);
__decorate([
    Property('Default')
], SplitterSettings.prototype, "view", void 0);
